import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "add-client-modal" }
const _hoisted_2 = { class: "add-client-modal__search" }
const _hoisted_3 = {
  key: 0,
  class: "add-client-modal__close"
}
const _hoisted_4 = ["onClick"]

import {
	computed,
	nextTick,
	onMounted,
	ref,
	watch
} from "vue";
import AppCheckbox from "@/components/ui-kit/checkbox/AppCheckbox.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import { ClientsApi, AttachClient } from "@/ api/ClientsApi";
import { clientPageStore } from "@/store/client-page";
import { debounce } from "lodash";

const take = 60

export default /*@__PURE__*/_defineComponent({
  __name: 'ClientAddUnionDropdown',
  props: {
    clientId: {},
    addedClients: {},
    showCloseIcon: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const $input = ref<typeof AppInput | null>(null)
const $body = ref<HTMLDivElement | null>(null)

const store = clientPageStore()

const isLoading = ref(true)
const filter = ref('')
const skip = ref(0)
const canLoadNext = ref(true)
const isClientsListInit = ref(false)
const clients = ref<AttachClient[] | null>(null)

const addedIds = computed(() => new Set((props.addedClients || []).map(c => c.Id)))

const filteredClients = computed<AttachClient[]>(() => {
	const list = clients.value || []
	const added = list.filter(c => addedIds.value.has(c.Id))
	const rest = list.filter(c => !addedIds.value.has(c.Id))
	return [...added, ...rest]
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

const onFetchClients = async () => {
	try {
		if (canLoadNext.value) {
			isLoading.value = true
			const clientsArray = await ClientsApi.getAttachClientsList(
				props.clientId,
				filter.value,
				skip.value,
				take
			)
			clients.value = skip.value === 0
				? clientsArray
				: clients.value
					? [...clients.value, ...clientsArray]
					: clientsArray
			skip.value += take

			if (clientsArray.length < take) {
				canLoadNext.value = false
			}
		}
	} catch (e) {
		console.error(e)
	} finally {
		isLoading.value = false
	}
}

const onOpen = async () => {
	try {
		await onFetchClients()
		isClientsListInit.value = true
		await nextTick(() => $input.value?.focusInput())
	} catch (e) {
		console.error(e)
	}
}

const onSearch = async () => {
	$body.value?.scrollTo({ top: 0 })
	canLoadNext.value = true
	skip.value = 0
	await onFetchClients()
}

const debouncedSearch = debounce(onSearch, 500)

const isClientAdded = (clientId: number) => addedIds.value.has(clientId)

const onAttach = async (clientId: number) => {
	try {
		isLoading.value = true
		await store.attachClientToUnion(clientId)
	} catch (e) {
		console.error(e)
	} finally {
		isLoading.value = false
	}
}

const onDetach = async (clientId: number) => {
	try {
		isLoading.value = true
		await store.detachClientFromUnion(clientId)
	} catch (e) {
		console.error(e)
	} finally {
		isLoading.value = false
	}
}

const onChangeClientStage = async (stage: boolean, clientId: number) => {
	if (stage) {
		await onAttach(clientId)
	} else {
		await onDetach(clientId)
	}
}

const onChangeClientStageFromName = async (clientId: number) => {
	if (isClientAdded(clientId)) {
		await onDetach(clientId)
	} else {
		await onAttach(clientId)
	}
}

watch(filter, (newVal, oldVal) => {
	if (newVal !== oldVal) {
		debouncedSearch()
	}
})

watch(isClientsListInit, (newValue) => {
	if (newValue) {
		nextTick(() => {
			$body.value?.addEventListener('scroll', async () => {
				if (canLoadNext.value && !isLoading.value) {
					if ($body.value?.scrollTop! + $body.value?.offsetHeight! > ($body.value?.scrollHeight! - 500)) {
						await onFetchClients()
					}
				}
			})
		})
	}
})

onMounted(() => onOpen())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(AppLoader, {
          key: 0,
          style: _normalizeStyle(loaderStyle.value)
        }, null, 8, ["style"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppInput, {
        ref_key: "$input",
        ref: $input,
        modelValue: filter.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter).value = $event)),
        class: "add-client-modal__search-input",
        placeholder: "Поиск",
        "show-search-button": ""
      }, null, 8, ["modelValue"]),
      (props.showCloseIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(AppIcon, {
              name: "close",
              width: "20px",
              color: "#D2D2D2",
              "hover-color": "#499259",
              cursor: "pointer",
              title: "Закрыть",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "add-client-modal__header" }, [
      _createElementVNode("div", { class: "add-client-modal__header-title" }, " Клиенты ")
    ], -1)),
    _createElementVNode("div", {
      class: "add-client-modal__body",
      ref_key: "$body",
      ref: $body
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredClients.value, (client) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "add-client-modal__body-item",
          key: client.Id
        }, [
          _createVNode(AppCheckbox, {
            style: { height: '16px', marginRight: '8px' },
            value: isClientAdded(client.Id),
            text: "",
            onInput: ($event: any) => (onChangeClientStage($event, client.Id))
          }, null, 8, ["value", "onInput"]),
          _createElementVNode("div", {
            class: "add-client-modal__body-item-text",
            onClick: ($event: any) => (onChangeClientStageFromName(client.Id))
          }, _toDisplayString(client.Name) + _toDisplayString(client.Address[0] ? `(${client.Address[0]})` : ''), 9, _hoisted_4)
        ]))
      }), 128))
    ], 512)
  ]))
}
}

})